module.exports = __webpack_public_path__ + "static/anim.81c2f1ed.png";